import { useEffect } from "react";
import { useTheme } from "../hooks/useTheme.ts";
import { getMarkUrl } from "./ui/logo.tsx";

/** Keeps `<link rel="icon">` aligned with the active brand pack. Mounted near
 *  the app root inside <ThemeProvider>; a single existing link element is
 *  reused (or created on first run). Hidden inside its own component to keep
 *  ThemeProvider free of asset imports — avoids the circular ref between
 *  themeProvider.tsx (ThemePack type) and logo.tsx (asset map). */
export function FaviconSync() {
  const { themePack } = useTheme();

  useEffect(() => {
    const href = getMarkUrl(themePack);
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    // SVG content-type lets Chrome/Firefox swap without a refresh.
    link.type = "image/svg+xml";
    link.href = href;
  }, [themePack]);

  return null;
}
